import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function reviewsSlider() {
  const swiperEl = document.getElementById('reviews-swiper');
  if (!swiperEl) return;

  const sidebarText = document.querySelector('.swiper-sidebar-text');
  const prevBtn = document.querySelector('.section-reviews__nav-btn--prev');
  const nextBtn = document.querySelector('.section-reviews__nav-btn--next');

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 40,
    speed: 500,
    loop: true,
    navigation: {
      prevEl: prevBtn,
      nextEl: nextBtn,
    },
    on: {
      init: function () {
        updateSidebarText(this);
      },
      slideChange: function () {
        updateSidebarText(this);
      },
    },
  });

  function updateSidebarText(swiperInstance) {
    if (!sidebarText) return;
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    const text = activeSlide.getAttribute('data-sidebar-text') || '';
    sidebarText.textContent = text;
  }
}
